import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaExclamationTriangle, FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import DocumentsComponent from "./companyComponent/documents";
import PictureComponent from "./companyComponent/pictures";
import RatioComponent from "./companyComponent/ratio";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { formatNumber, truncateText } from "../../../../../utility/helper";
import {
  addMediaService,
  deleteMediaService,
  deleteTransaction,
  getFutureTransaction,
  getTransaction,
  getUserAssets,
} from "../../../../../services/transaction";
import { filterDropdownOptions } from "../../../../../utility/data";
import { getLuxaryTransaction } from "../../../../../services/legacy/legacyApi";

import ReturnComponent from "./companyComponent/returnComponent";
import {
  getGraphServices,
  getMediaService,
  getStatsService,
} from "../../../../../services/company";
import MovementComponent from "../company/companyComponent/movement";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { useLocation } from "react-router-dom";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownOptions = [
    { name: "EXPENSE" },
    { name: "INCOME" },
    { name: "SELL" },
    { name: "VALUATION" },
  ];
  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [graphROI, setGraphROI] = useState([]);
  const [page, setPage] = useState(0);
  const [filterType, setFilterType] = useState(filterDropdownOptions[0]);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [statsData, setStatsData] = useState({});
  const [mediaData, setMediaData] = useState([]);
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const selectedAsset = useSelector((state) => state.userAssets.selectedAsset);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [mediaLoading, setMediaLoading] = useState(false);
  const location = useLocation();
  const id = location?.state?.id || null;

  useEffect(() => {
    if (selectedAsset) {
      GetTransactionData();
      GetMediaData();
      GetRoiData();
      GetstatsData();
    }
  }, [selectedAsset, filterType, page]);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 5, selectedAssetId: id }));
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetMediaData = async () => {
    setLoading(true);
    try {
      const response = await getMediaService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetRoiData = async () => {
    setLoading(true);
    try {
      const response = await getGraphServices(selectedAsset.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setGraphROI(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetstatsData = async () => {
    setLoading(true);
    try {
      const response = await getStatsService(selectedAsset.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setStatsData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTransaction(
        selectedAsset?.id,
        5,
        page * limit,
        limit,
        filterType,
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleMediaDelete = async (media_id) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        fetchUserAssets();
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "File deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    setMediaLoading(true);
    try {
      const response = await addMediaService(
        media,
        selectedAsset.id,
        "Company",
        accessToken
      );
      if (response) {
        GetMediaData();
        fetchUserAssets();
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "File upload successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      setMediaLoading(false);
    }
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      if (response) {
        fetchUserAssets();
        GetTransactionData();
        GetstatsData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const confirmMediaDelete = (mediaId, fileType) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: `Are you sure you want to delete this ${
        fileType ? fileType : "Media"
      }?`,
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleMediaDelete(mediaId, fileType),
    });
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div
        className={`relative ${
          mediaLoading ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        <div className="text-gray-400">
          <CustomDropdown
            options={userAssets}
            name={selectedAsset?.name || "Select Asset"}
            assetId={selectedAsset?.id || null}
            onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
            returnFullObject={true}
            truncateText={truncateText}
            size={19}
            className="inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md hover:border hover:border-secondary"
          />
        </div>
        <div className="grid md:grid-cols-12 grid-cols-4">
          <div className="md:col-span-2 col-span-4 text-sm">
            <div className="grid md:grid-cols-2 grid-cols-4 gap-1">
              <div className="ml-1">{selectedAsset?.name ?? ""}</div>
              <div className="flex justify-around whitespace-nowrap font-bold">
                <span className="mr-4">CHF</span>
                {formatNumber(
                  Number(statsData?.valuation) !== 0
                    ? Number(statsData?.valuation ?? 0).toFixed(2)
                    : Number(statsData?.initial_balance ?? 0).toFixed(2)
                )}
              </div>
            </div>
            <div className="grid md:grid-cols-2 grid-cols-4 gap-1 mt-2">
              <div className="ml-1 text-sm font-bold">
                {statsData?.ownership_type ?? ""}
              </div>
              <div className="text-secondary flex justify-end mr-1 font-bold">
                <span className=""></span>
                <span className="">
                  {formatNumber(Number(statsData?.ownership ?? 0).toFixed(2))}%
                </span>
              </div>
            </div>
          </div>

          <div className="md:col-span-9 col-span-4 text-end whitespace-nowrap text-[0.70rem]">
            <div className="grid md:grid-cols-5 grid-cols-4 gap-2 font-bold">
              <div className="text-sm ml-7">
                <span
                  className={`mr-5 ${
                    Number(statsData?.crr ?? 0) < 0 &&
                    Number(statsData?.roi ?? 0) < 0
                      ? "text-expense"
                      : "text-secondary"
                  }`}
                >
                  CHF
                </span>
                <span
                  className={`${
                    Number(statsData?.crr ?? 0) < 0 &&
                    Number(statsData?.roi ?? 0) < 0
                      ? "text-expense"
                      : "text-secondary"
                  }`}
                >
                  {formatNumber(Number(statsData?.crr ?? 0).toFixed(2))}
                </span>
                <span
                  className={`ml-10 ${
                    Number(statsData?.crr ?? 0) < 0 &&
                    Number(statsData?.roi ?? 0) < 0
                      ? "text-expense"
                      : "text-secondary"
                  }`}
                >
                  {formatNumber(Number(statsData?.roi ?? 0).toFixed(2))}%
                </span>
              </div>

              <div className="">Realised profit</div>
              <div
                className={`ml-16 flex justify-between gap-5 ${
                  Number(statsData?.realized ?? 0) < 0
                    ? "text-expense"
                    : "text-secondary"
                }`}
              >
                <span className="">CHF</span>
                <span className="">
                  {formatNumber(Number(statsData?.realized ?? 0).toFixed(2))}
                </span>
              </div>

              <div className="">INCOME</div>
              <div className="text-secondary ml-16 flex justify-between gap-5">
                <span className="">CHF</span>
                <span className="">
                  {formatNumber(Number(statsData?.income ?? 0).toFixed(2))}
                </span>
              </div>
            </div>
            <div className="grid md:grid-cols-5 grid-cols-4 gap-2 mt-2 font-bold">
              <div className="text-secondary"></div>
              <div className="">Unrealised profit</div>
              <div
                className={`ml-16 flex justify-between gap-5 ${
                  Number(statsData?.unrealized ?? 0) < 0
                    ? "text-expense"
                    : "text-secondary"
                }`}
              >
                <span className="">CHF</span>
                <span className="">
                  {formatNumber(Number(statsData?.unrealized ?? 0).toFixed(2))}
                </span>
              </div>

              <div className="">EXPENSE</div>
              <div className="text-expense ml-16 flex justify-between gap-5">
                <span className="">CHF</span>
                <span className="">
                  {formatNumber(Number(statsData?.expense ?? 0).toFixed(2))}
                </span>
              </div>
            </div>
            <div className="grid md:grid-cols-5 grid-cols-4 gap-2 mt-3 font-bold">
              <div className="text-secondary"></div>
              <div className="">Market Value</div>
              <div
                className={`ml-16 flex justify-between gap-5 ${
                  Number(statsData?.market_value ?? 0) < 0
                    ? "text-expense"
                    : "text-secondary"
                }`}
              >
                <span className="">CHF</span>
                <span className="">
                  {formatNumber(
                    Number(statsData?.market_value ?? 0).toFixed(2)
                  )}
                </span>
              </div>

              <div className="">EBITDA Multiples</div>
              <div className="text-secondary ml-16 flex justify-between gap-5">
                <span className=""></span>
                <span className="">
                  {formatNumber(Number(statsData?.multiples ?? 0).toFixed(2))}x
                </span>
              </div>
            </div>
          </div>
          <div className="text-end">
            <CustomDropdown
              options={dropdownOptions}
              name={""}
              assetId={""}
              icon={<FaPlus />}
              direction={"right"}
              truncateText={truncateText}
              size={19}
              className={`flex items-center justify-center w-12 h-12 rounded-full font-bold bg-secondary text-primary hover:bg-[#148f77]`}
              onOptionSelect={(option) =>
                handleOptionSelect(option, "Create", {})
              }
            />
          </div>
        </div>
        <div className="border-b border-[rgb(35,135,159)] pt-3"></div>
        <div className="grid md:grid-cols-8 grid-cols-4 mt-2">
          {["Return", "Documents", "Movements", "Ratio"].map((btn) => (
            <button
              key={btn}
              className={
                selectedButton === btn ? "text-secondary font-bold" : ""
              }
              onClick={() => setSelectedButton(btn)}
            >
              {btn}
            </button>
          ))}
        </div>

        <div className="mt-5">
          {selectedButton === "Return" && (
            <ReturnComponent graphROI={graphROI} />
          )}
          {selectedButton === "Documents" && (
            <DocumentsComponent
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
            />
          )}
          {selectedButton === "Ratio" && <RatioComponent />}
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
            />
          )}
        </div>

        <CreateTransactionModal
          visible={modalVisible}
          singleTransactionData={singleTransactionData}
          actionTypes={actionTypes}
          fetchTransactionData={GetTransactionData}
          GetstatsData={GetstatsData}
          GetRoiData={GetRoiData}
          viewTransaction={viewTransaction}
          onHide={() => {
            setModalVisible(false);
          }}
          SelectType={type}
          toast={toast}
          loading={loading}
          setLoading={setLoading}
          assetName={selectedAsset}
        />
      </div>
      {mediaLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <ProgressSpinner />
        </div>
      )}
    </>
  );
};

export default ViewTransaction;
